export default __webpack_public_path__ + "static/media/Ger.226d2851.jpg";